// extracted by mini-css-extract-plugin
export default {"share-button-container":"ZtNMy","share-button":"toclP","linkedin":"ubN2H"};